export default [
  {
    name: "Creative workshops",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative.jpg",
    copy: "Learn a new skill with one of our creative workshops. Kits will be delivered with everything you need. Some of our favourites include candle making, flower arranging, life drawing classes and terrarium making.",
    slug: "creative-workshops",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_header_image_1.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_header_image_2.jpg",
    ],
    events: [
      {
        name: "Candle Making",
        copy: "You'll make a range of hand made, vegan, soy wax candles. Kits will be delivered in advance of the virtual event with all the equipment you need. At the end of the activity you will have a beautiful set of candles to keep for yourself or give as a gift.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_candle_making.jpg",
      },
      {
        name: "Life Drawing",
        copy: "This workshop is suitable for all levels of experience. Taught by a professional art tutor you'll learn about key areas such as proportion, perspective, shading and tone to help achieve your own work of art.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_life_drawing.jpg",
      },
      {
        name: "Flower Arranging",
        copy: "Learn how to arrange like a pro with a flower arranging workshop. You'll be guided through the steps by a professional florist. Piecing everything together to create your own bouquet.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_flower_arranging.jpg",
      },
      {
        name: "Terrarium Making",
        copy: "Escape to a virtual tropical garden with a terrarium making workshop. Guided by a plant expert you will be sent everything you need to create your own terrarium.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/creative_workshops_terrarium_workshops.jpg",
      },
    ],
  },
  {
    name: "Conference energisers and team building",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_header.jpg",
    copy: `Break up your virtual conference with our pick of energisers and teambuilding activities. Get crafty with a company masterpiece challenge or discover whether your company has the next TikTok star with a dance workshop.`,
    slug: "conferences",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_header_image_2.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_header_image_1.jpg",
    ],
    events: [
      {
        name: "Company Masterpiece",
        copy: "Your team will recreate a piece of art composing of smaller sections created by each partipant. Get creative using anything from paint, pasta, collage to create your section of the masterpiece. Go bespoke by recreating the company logo or vision.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_masterpiece.jpg",
      },
      {
        name: "The Haka",
        copy: "The Haka is the perfect icebreaker or energiser for your virtual conference or meeting. Lead by Maori warriors this activity allows you and your colleagues to learn this sacred tradition - guaranteed to empower, motivate and unite teams.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_haka.jpg",
      },
      {
        name: "Dance Class",
        copy: "Put on your dancing shoes and step away from the computer screen. Lead by a professional dance instructor you can choose from a range of dances including TikTok style choreography, hip-hop or learn an iconic dance from stage or screen.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_dance_class.jpg",
      },
      {
        name: "Company Music Video",
        copy: "See who has got the X factor in your company by creating your own music video. Split into teams  you'll create a section of the video that will then be edited together. Perfect for playing at your next office party.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/conference_company_company_music_video.jpg",
      },
    ],
  },
  {
    name: "Entertainment",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_singer.jpg",
    copy: `From live music performances, comedy acts, magicians we've got you covered with the best entertainment to wow your colleagues or clients.`,
    slug: "entertainment",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_header_image_1.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_header_image_2.jpg",
    ],
    events: [
      {
        name: "Comedy Night",
        copy: "From up and coming comedians to stars of the silver screen, we'll create a comedy line up to suit your audience. Hilarious and highly interactive this a great way to boost your teams morale whether it be at the end of a virtual conference or part of your company party.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_comedy.jpg",
      },
      {
        name: "DJ and Live Band",
        copy: "Get the party started by adding a DJ or live band to your virtual event. We've got access to the best entertainers that are sure to get your guests dancing. An ideal way to enhance your virtual company party.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_dj.jpg",
      },
      {
        name: "Magician",
        copy: "Captivate your audience with a magic show. Suitable for all group sizes our virtual magicians will perform mind blowing tricks that will have you on the edge of your seat. A great add on to a range of virtual events from conferences, team events, company parties.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_magician.jpg",
      },
      {
        name: "Sofar Sounds Virtual Concert",
        copy: "A personalised private music experience that brings your people together, no matter where they are. Sofar Sounds will work with you to curate a line up of incredible emerging artists. A unique, authentic and fun experience for everyone to love as well as supporting artists during the pandemic.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/entertainment_gig.jpg",
      },
    ],
  },
  {
    name: "Investigation activities",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/murder_mysteries.jpg",
    copy: "Activities that will get your teams working collaboratively, including murder mysteries, escape rooms and crime scene investigations. Can you crack the codes?",
    slug: "escape-rooms-murder-mysteries",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_header_image_1.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_header_image_2.jpg",
    ],
    events: [
      {
        name: "Art Heist Escape Room",
        copy: "Highly engaging and interactive, the Art Heist virtual escape room will test your teams problem-solving skills. Complete a series of cryptic tasks, riddles and puzzles to escape.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_art_heist_escape_room.jpg",
      },
      {
        name: "Arctic Survival Escape Room",
        copy: "Test your survival instincts in a race against time. This arctic themed virtual escape room will have you working collaboratively in teams to crack the code and complete your rescue mission.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_arctic_survival_escape_room.jpg",
      },
      {
        name: "Murder Mystery",
        copy: "Choose from either an app based 'Cluedo style' murder mystery or include live professional actors in the ultimate 'who dunnit?'. You'll be set challenges to try and discover who commited the murder.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_murder_mystery.jpg",
      },
      {
        name: "Crime Scene Investigation",
        copy: "Created by senior ex-detectives and forensic scientists this immersive experience will have you testing fingerprints, analysing police statements and much more to solve the crime.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/investigation_activities_crime_scene.jpg",
      },
    ],
  },
  {
    name: "Food and drink activities",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink.jpg",
    copy: `Guided by professional chefs and mixologists we've got a range of activities that will test your skills in the kitchen. Cook up a Chinese feast, mix up a mojito or alternatively sit back and enjoy a wine tasting with a sommelier.`,
    slug: "food-drink",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_header_image_1.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_header_image_2.jpg",
    ],
    events: [
      {
        name: "Cookery Workshop",
        copy: "Lead by a professional chef you'll learn to cook a selection of delicious dishes. Choose from a range of cuisines including Thai, Chinese, Vietnamese, pizza making, sushi making or see if you're a star baker by baking some sweet treats.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_cookery_workshop.jpg",
      },
      {
        name: "Chocolate Making",
        copy: "Perfect for chocoholics, we'll send you everything you need to create luxury truffles from home. Led by a professional chocolatier you'll learn how to mix ganache, pipe like a pro and how to decorate your truffles. You can then decide whether to give as a gift or enjoy all for yourself.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_chocolate_making.jpg",
      },
      {
        name: "Cocktail Making",
        copy: "Hosted by a professional mixologist, you'll be sent everything you need to mix up some delicious cocktails. You'll also learn some cool tricks and skills of the trade along the way. A good way to mix up your company virtual happy hour, client entertainment or team event.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_cocktail_making.jpg",
      },
      {
        name: "Wine Tasting",
        copy: "Now that we have got Dry January out the way tastings are incredibly popular for virtual team events and client entertainment. Hosted by a professional wine sommelier you'll go on a journey tasting and learning about wines from around the world. Not a fan of wine? How about a gin, beer or whisky tasting instead.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/food_drink_wine_tasting.jpg",
      },
    ],
  },
  {
    name: "Interactive quizes and games",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/quiz.jpg",
    copy: `Not just another quiz... we've got a range of interactive activities that will get you out of your seat from musical bingo and scavenger hunts you can do from the comfort of your own home.`,
    slug: "quizes-games",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_header_image_1.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_header_image_2.jpg",
    ],
    events: [
      {
        name: "Customised Quizzes",
        copy: "Not just another zoom quiz... we've got a selection of fun and interactive quizes. Include rounds inspired by your favourite TV gameshows or why not bespoke with content about your company. All hosted by a professional compere.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_quiz.jpg",
      },
      {
        name: "Musical Bingo",
        copy: "Like normal bingo but with songs. Choose your favourite genre from pop, rock, musicals, the decades... plus many more. A great way to get the party started or perfect as a team event.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_musical_bingo.jpg",
      },
      {
        name: "Remote Scavenger Hunt",
        copy: "Race against the clock to complete 20 bespoke challenges around the home. Including searching for items, photo and video tasks. The hunt ends with a screening of the hilarious highlights and winners ceremony.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_scavenger_hunt.jpg",
      },
      {
        name: "Horse Racing",
        copy: "Bring the races to your living room with a virtual horse racing night. Hosted by a live 'bookie' you will be competing against one another to see who can win the most fun money. Who will be the champion?",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/games_quizes_horse_racing.jpg",
      },
    ],
  },
  {
    name: "Wellbeing workshops",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing.jpg",
    copy: `With teams working remotely for the forseeable it's more important than ever to invest in their physical and mental wellbeing. From coaching, yoga and meditation our virtual events experts will work with you to curate a wellbeing programme.`,
    slug: "wellbeing",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_header_image_2.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_header_image_1.jpg",
    ],
    events: [
      {
        name: "Meditation and Mindfullness",
        copy: "Calm the mind, reduce stress and focus on the present with a meditation and mindfulness session. Lead by a trained instructor these sessions equip your teams with the skills that can be carried on in daily life.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_madison_lavern.jpg",
      },
      {
        name: "Fitness Classes",
        copy: "We're stuck at our desks all day. Improve your employees physical and mental wellbeing with a fitness class. From HIIT classes, dance workshops, yoga and pilates all lead by a trained instructor.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_fitness.jpg",
      },
      {
        name: "Wellbeing Retreats",
        copy: "Take a break from the day to day stresses with a wellbeing retreat. Create a half day or full day of sessions that explore the mind, body and soul. From meditation to sound healing and movement this is the ultimate feel good experience. ",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_retreats.jpg",
      },
      {
        name: "Yoga",
        copy: "A great way to kickstart the morning and get your body moving and energised. Working with a professional yoga instructor custom programmes can be created. Choose from a one off session or introduce regular classes.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/wellbeing_yoga.jpg",
      },
    ],
  },
  {
    name: "Catering",
    img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering.jpg",
    copy: "From themed snack hampers and cocktail kits, delicious grazing boards and three course dinners. This is the best way to enhance your virtual event.",
    slug: "catering",
    categoryHeroImages: [
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_header_image_2.jpg",
      "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_header_image_1.jpg",
    ],
    events: [
      {
        name: "Hampers and Gifting",
        copy: "Looking to reward your team or simply boost morale, hampers are the ideal solution. With a range of options available to suit your requirements from wine hampers, afternoon tea boxes to snack hampers that support British food start ups.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_hampers.jpg",
      },
      {
        name: "Catering Boxes and Meal Kits",
        copy: "From delicious tacos and pizza making kits to full three course meals. We've got something for every occasion. With bespoke options available this is the perfect way to enhance a themed virtual event.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_boxes_meal_kits.jpg",
      },
      {
        name: "Drinks and Canape Reception",
        copy: "Get the party started with a drinks hamper or DIY canape reception. Hampers can be created with pre-mixed cocktails or all the ingredients can be sent out so that you can create at home following a live mixologist.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_drinks_and_canape.jpg",
      },
      {
        name: "Takeaway",
        copy: "Let your guests choose what they would like to eat during your virtual event. Voucher codes for food delivery sites such as Uber Eats and Deliveroo are a great solution for this.",
        img: "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/catering_takeaway.jpg",
      },
    ],
  },
];
